"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateBundle = exports.getEnvironment = exports.requireAMDModule = exports.getGlobal = void 0;
/* eslint-disable no-new-func */
/* eslint-disable no-eval */
var RegistryError_1 = require("../errors/RegistryError");
var flags_1 = require("../flags");
var workaround = {};
/**
 * trick to leave `require` as is after webpack build
 * it makes possible to run the same bundle on server and client
 */
eval("workaround.getRequireFunction = () => typeof require !== 'undefined' ? require : undefined");
function getGlobal() {
    var currentGlobal = (typeof globalThis !== 'undefined'
        ? globalThis
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : typeof global !== 'undefined'
                    ? global
                    : null);
    /**
     * Temporary condition
     */
    if (currentGlobal === null) {
        console.log('');
        console.error("Registry Unreachable Case \u2013 \"get global variable\". \nPlease notify registry developers about this error.");
        console.log('');
    }
    return currentGlobal;
}
exports.getGlobal = getGlobal;
function requireAMDModule(id) {
    /**
     * This is workaround for webpack...
     * if just use `require` function directly, webpack will transpile it to
     * `__webpack_require__(n)` that always leads to module that throws exception like `module if not defined`
     */
    var localRequire = workaround.getRequireFunction();
    if (!localRequire.specified) {
        throw RegistryError_1.createInternalException('"specified()" is not available from the "require" function');
    }
    return new Promise(function (resolve) {
        /**
         * Trigger `require` to fix `require.specified`
         * https://github.com/requirejs/requirejs/issues/1305#issuecomment-87924865
         **/
        localRequire([]);
        /**
         * To prevent fetching module with `requirejs`
         */
        if (localRequire.specified(id)) {
            localRequire([id], function (model) {
                resolve(model);
            });
        }
        else {
            resolve(undefined);
        }
    });
}
exports.requireAMDModule = requireAMDModule;
var parseDefineArguments = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 3) {
        return {
            id: args[0],
            deps: args[1],
            factory: args[2],
        };
    }
    else if (args.length === 2) {
        return {
            id: typeof args[0] === 'string' ? args[0] : null,
            deps: Array.isArray(args[0]) ? args[0] : [],
            factory: args[1],
        };
    }
    else {
        return null;
    }
};
function wrapDefineFunction(params) {
    /**
     * If components library was bundled with "umdNamedDefine: true", the UMD header in bundle will be:
     * ...
     * define('bundleId', [], factory)
     * ...
     *
     * If components "umdNamedDefine: false":
     * ...
     * define([], factory)
     * ...
     *
     * So this is anonymous define call, that means that it is not possible to require it after the evaluation
     * Better to track these cases.
     */
    var defineForBundle;
    if (params.define) {
        defineForBundle = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var parsed = parseDefineArguments.apply(void 0, args);
            if (parsed === null) {
                throw RegistryError_1.createException("Incorrect \"define()\" call. No arguments", RegistryError_1.RegistryErrorCode.BundleEvaluationError).withHint('Probably library was bundled in a wrong way');
            }
            var id = parsed.id, deps = parsed.deps, factory = parsed.factory;
            if ((params.id && params.id !== id) || !id) {
                throw RegistryError_1.createException("Incorrect \"define()\" call. Bundle IDs miss match", RegistryError_1.RegistryErrorCode.BundleEvaluationError)
                    .withMissMatch("" + params.id, "" + id)
                    .withHint('Probably library was bundled in a wrong way');
            }
            var globals = params.globals;
            var filteredDeps = deps.filter(function (key) { return !globals || (globals && !globals[key]); });
            if (globals) {
                params.define(id, filteredDeps, function () {
                    var values = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        values[_i] = arguments[_i];
                    }
                    var allValues = deps.map(function (dep) {
                        var index = filteredDeps.findIndex(function (_dep) { return _dep === dep; });
                        if (index === -1) {
                            return globals[dep];
                        }
                        else {
                            return values[index];
                        }
                    });
                    return factory.apply(void 0, allValues);
                });
            }
            else {
                params.define.apply(params, args);
            }
        };
        defineForBundle.amd = params.define.amd;
    }
    return defineForBundle;
}
function getDefineFunction() {
    var currentGlobal = getGlobal();
    return typeof currentGlobal.define === 'function' && currentGlobal.define.amd
        ? currentGlobal.define
        : null;
}
function getEnvironment(_a) {
    var id = _a.id, globals = _a.globals;
    var currentGlobal = getGlobal();
    var _define = getDefineFunction();
    var self = currentGlobal;
    if (globals && !_define) {
        self = new Proxy(currentGlobal, {
            get: function (target, key) {
                return key in globals ? globals[key] : target[key];
            },
        });
    }
    var currentRequire = workaround.getRequireFunction();
    return {
        /**
         * for requirejs environment
         */
        define: wrapDefineFunction({ id: id, define: _define, globals: globals }),
        /**
         * `workaround.require` – always default require function
         * for SSR – it is node require
         * for CSR – it is requirejs
         */
        require: currentRequire
            ? function (name) {
                if (globals && globals[name]) {
                    return globals[name];
                }
                return currentRequire(name);
            }
            : undefined,
        /**
         * always force `module` to be undefine during bundle evaluation
         */
        module: undefined,
        /**
         * commonjs & commonjs2
         *
         * for server env. we provide `exports` as plain object
         * after evaluation, it is possible to get the results:
         * env.exports[bundleId]
         *
         * check "typeof currentRequire !== 'undefined'" to support SSR web-worker emulation
         */
        exports: flags_1.isServer && typeof currentRequire !== 'undefined' ? {} : undefined,
        /**
         *
         */
        self: self,
    };
}
exports.getEnvironment = getEnvironment;
function evaluateBundle(bundle, _a) {
    var _b = _a === void 0 ? {} : _a, id = _b.id, globals = _b.globals;
    var evaluateBundleSources = new Function('define', 'require', 'module', 'exports', 'self', bundle);
    var env = getEnvironment({ id: id, globals: globals });
    var backup = {};
    var currentGlobal = getGlobal();
    evaluateBundleSources(env.define, env.require, env.module, env.exports, env.self);
    Object.keys(backup).forEach(function (key) {
        currentGlobal[key] = backup[key];
    });
    /**
     * Nothing to return bundle id was not passed
     */
    if (!id) {
        return undefined;
    }
    if (typeof env.define === 'function') {
        return requireAMDModule(id);
    }
    else if (typeof env.exports === 'object') {
        env.self[id] = env.exports[id];
        return currentGlobal[id];
    }
    else {
        var root = typeof self !== 'undefined' ? self : currentGlobal;
        // @ts-ignore
        return root[id];
    }
}
exports.evaluateBundle = evaluateBundle;
//# sourceMappingURL=evaluateBundle.js.map